<figure class="d-flex flex-column">
  <img alt="GVP-Mitgliedsurkunde" class="mx-auto h-50 w-25" ngSrc="assets/images/GVP-Mitgliedsurkunde.png" height="1753" width="1240">
  <figcaption class="mx-auto"><a href="assets/pdf/GVP-Mitgliedsurkunde.pdf">GVP-Mitgliedsurkunde.pdf</a></figcaption>
</figure>
